//

// TODO: update to allow more variants, such as off-host and on-host
export const isLocalDev = process.env.NODE_ENV === 'development'

const config = {
  // note: Lane was used in logging events, but if we're not going to use it,
  // we should remove it. -BJG
  // lane: "p",
  build: '202601310845',
  // backend api
  app: 'https://api.libreon.net',
  // frontend website
  web: 'https://libreon.net',
  // public CDN
  pub: 'https://i.libreon.net/',
  ws: '/socket',
  graphql: '/graphql', // @GRAPHQL@
  authapi: '/authx/v1/api/', // @AUTHAPI@
  name: 'default',
  nameAn: 'default',
  nameShort: 'default',
  nameLegal: 'default',
  gaKey: 'default', // @GAKEY@
  siteLogo: undefined,
  auth: {
    local: true,
    federated: ['google'],
    google: {
      appId:
        '370077008372-k4fvmcb357sdjjeu8q8hdnui00aphitq.apps.googleusercontent.com'
    }
  },
  // the above settings are overridden by site-specific runtime configs which
  // come in from `/assets/config/config.js` which is loaded via the <head>
  // defined in the public/index.html file; which is loaded and put into
  // window.config
  ...window.config
}

////////////////////////////////////////////////////////////////////////////////
// monkey patching
// IO.inspect
console.inspect = (val, ...labels) => {
  console.log('INSPECT>', ...labels, val)
  return val
}

////////////////////////////////////////////////////////////////////////////////
// because people still run old stuff (yikes)
if (!Array.prototype.toSorted) {
  Array.prototype.toSorted = function (cmp) {
    // eslint-disable-line
    return this.slice().sort(cmp)
  }
}

/*
if (!Iterator.prototype.toArray) {
  Iterator.prototype.toArray = function (cmp) { // eslint-disable-line
    return Array.from(this)
  }
}
*/

////////////////////////////////////////////////////////////////////////////////

window.VERSION_OUTDATED = false
async function check_version() {
  const resp = await fetch('/site.json')
  const data = await resp.json()
  console.log('Version Change?', { old: config.build, new: data.build })
  if (config.build !== data.build) {
    window.VERSION_OUTDATED = true
  }
}

const RECHECK_INTERVAL = 3600_000 // every hour
setInterval(check_version, RECHECK_INTERVAL)

export default config
